var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 9.5H26C23.7908 9.5 22 11.2908 22 13.5C22 15.7092 23.7908 17.5 26 17.5H34C36.2092 17.5 38 15.7092 38 13.5C38 12.4856 37.6223 11.5593 37 10.8542",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.1458C18.3776 11.4407 18 10.5144 18 9.5C18 7.29085 19.7909 5.5 22 5.5H30C32.2092 5.5 34 7.29085 34 9.5C34 11.7092 32.2092 13.5 30 13.5H25",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLinks);
export default __webpack_public_path__ + "static/media/ClientLinks.8c699f62.svg";
export { ForwardRef as ReactComponent };